<template>
  <v-container class="text-center">
    <v-row justify="center" align="center" style="height: 100vh;">
      <v-col cols="12" md="6">
        <h1>403</h1>
        <p>You do not have permission to view this page.</p>
        <v-btn color="primary" @click="goHome">
          Go to Dashboard
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AccessDeniedView',
  methods: {
    goHome() {
      this.$router.push({ name: 'Dashboard' });
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 5rem;
  font-weight: bold;
}
p {
  font-size: 1.25rem;
  margin-bottom: 1rem;
}
</style>
